import { Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import InputText, { INPUT_TEXT_TYPE } from "../../../components/InputText";
import Button from "../../../components/Button";
import { FC } from "react";
import { PASSWORD_CRITERIA } from "../../../utils/Constants";
import useResetPasswordMutation from "../hooks/useResetPasswordMutation";
import {
  getConfirmPasswordValidationRules,
  getPasswordValidationRules,
} from "../../../helpers/formValidationRules";
import { useTranslation } from "react-i18next";

interface SetAccountPasswordFormProps {
  email?: string;
  onSuccess?: () => void;
  onError?: () => void;
}

const SetAccountPasswordForm: FC<SetAccountPasswordFormProps> = ({
  email,
  onSuccess,
  onError,
}) => {
  const { t } = useTranslation();
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      newPassword: "",
      confirmPassword: "",
    },
  });

  const isDisabled = !watch("newPassword") || !watch("confirmPassword");

  const { mutate: resetPasswordMutate, isPending: isResettingPassword } =
    useResetPasswordMutation();

  return (
    <>
      <Typography fontWeight={700} variant="h5">
        {t("Set_Your_Account_Password")}
      </Typography>
      <Typography mt={2}>{t("Password_Criteria")}</Typography>
      <ul
        style={{
          textAlign: "left",
          fontSize: 16,
          marginTop: 0,
          paddingLeft: 18,
        }}
      >
        {PASSWORD_CRITERIA.map((criteria) => (
          <li key={criteria}>
            <Typography>{t(criteria)}</Typography>
          </li>
        ))}
      </ul>

      <InputText
        type={INPUT_TEXT_TYPE.PASSWORD}
        control={control}
        name="newPassword"
        label={t("Enter_Password")}
        sx={{
          mb: 3,
        }}
        rules={getPasswordValidationRules()}
      />
      <InputText
        type={INPUT_TEXT_TYPE.PASSWORD}
        control={control}
        name="confirmPassword"
        label={t("Confirm_Password")}
        rules={getConfirmPasswordValidationRules(watch("newPassword"))}
        sx={{
          mb: 3,
        }}
      />
      <Button
        onClick={handleSubmit((val) => {
          email &&
            resetPasswordMutate(
              {
                email,
                newPassword: val?.confirmPassword,
              },
              { onSuccess: onSuccess, onError: onError }
            );
        })}
        type="submit"
        variant="contained"
        fullWidth
        disabled={isDisabled || isResettingPassword}
        sx={{
          backgroundColor: "custom.background.brand",
          textTransform: "none",
          fontSize: 16,
        }}
      >
        {t("Submit")}
      </Button>
    </>
  );
};

export default SetAccountPasswordForm;
